import createIcon from '../../createIcon';

/**
 * @component @name CoPresent
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjEgMi41SDNDMS45IDIuNSAxIDMuNCAxIDQuNVYxMi41SDNWNC41SDIxVjIwLjVDMjIuMSAyMC41IDIzIDE5LjYgMjMgMTguNVY0LjVDMjMgMy40IDIyLjEgMi41IDIxIDIuNVoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik05IDEzLjVDMTEuMjA5MSAxMy41IDEzIDExLjcwOTEgMTMgOS41QzEzIDcuMjkwODYgMTEuMjA5MSA1LjUgOSA1LjVDNi43OTA4NiA1LjUgNSA3LjI5MDg2IDUgOS41QzUgMTEuNzA5MSA2Ljc5MDg2IDEzLjUgOSAxMy41WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTE1LjM5IDE2LjA2QzEzLjcxIDE1LjIgMTEuNTMgMTQuNSA5IDE0LjVDNi40NyAxNC41IDQuMjkgMTUuMiAyLjYxIDE2LjA2QzEuNjEgMTYuNTcgMSAxNy42IDEgMTguNzJWMjEuNUgxN1YxOC43MkMxNyAxNy42IDE2LjM5IDE2LjU3IDE1LjM5IDE2LjA2WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const CoPresent = createIcon('CoPresent', [
  [
    'path',
    {
      d: 'M21 2.5H3C1.9 2.5 1 3.4 1 4.5V12.5H3V4.5H21V20.5C22.1 20.5 23 19.6 23 18.5V4.5C23 3.4 22.1 2.5 21 2.5Z',
      key: '14vzqm',
    },
  ],
  [
    'path',
    {
      d: 'M9 13.5C11.2091 13.5 13 11.7091 13 9.5C13 7.29086 11.2091 5.5 9 5.5C6.79086 5.5 5 7.29086 5 9.5C5 11.7091 6.79086 13.5 9 13.5Z',
      key: '1572t8',
    },
  ],
  [
    'path',
    {
      d: 'M15.39 16.06C13.71 15.2 11.53 14.5 9 14.5C6.47 14.5 4.29 15.2 2.61 16.06C1.61 16.57 1 17.6 1 18.72V21.5H17V18.72C17 17.6 16.39 16.57 15.39 16.06Z',
      key: '1dbxts',
    },
  ],
]);

export default CoPresent;
